import React from 'react';

interface StatCardProps {
  label: string;
  value: string | number;
  icon: React.ReactNode;
  colorClass: string; // Expects dark mode utilities, e.g. "bg-blue-500/10 text-blue-400"
}

const StatCard: React.FC<StatCardProps> = ({ label, value, icon, colorClass }) => (
  <div className="bg-slate-950 p-5 rounded-3xl border border-slate-800 flex items-center justify-between shadow-xl">
    <div>
      <p className="text-slate-500 text-[10px] font-black uppercase tracking-wider mb-1">
        {label}
      </p>
      <h3 className="text-2xl font-black text-white tracking-tight">
        {value}
      </h3>
    </div>
    <div className={`p-3 rounded-2xl flex items-center justify-center ${colorClass}`}>
      {icon}
    </div>
  </div>
);

export default StatCard;